module.exports = __webpack_public_path__ + "static/media/53.1073eafa.png";